/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/mv_difference.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns the values that appear in the first field, except those that appear in the second. Returns `null` if the first expression is null (nothing to remove) or the value of the first field if the second is null.',
  examples: [
    'ROW values = ["a", "b", "c"], element = "a"\n| EVAL result = mv_difference(values, element)',
  ],
  params: {
    field1: 'Expression that can be null, a single value, or multiple values. If null, the function returns null.',
    field2: 'Expression that can be null, a single value, or multiple values. If null, the function returns field1.',
  },
};

export default docs;
